<!-- @format -->

<template>
	{{ description }}
</template>

<script setup lang="ts">
	interface Props {
		modelValue: any;
		options: any;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
	});

	const getLabel = (value, params) => params.find((it) => it.value === value)?.label;

	const description = computed(() => {
		if (props.options.params && props.modelValue) {
			return props.modelValue
				.split(',')
				.map((itm) => getLabel(itm, props.options.params))
				.toString();
		} else {
			return props.modelValue;
		}
	});
</script>

<style scoped></style>
